module.exports = __webpack_public_path__ + "static/media/7-piggies.7983dae2.gif";